"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var primary = {
  50: '#E4F2FE',
  100: '#BCE0FB',
  200: '#90CBF9',
  300: '#64B6F7',
  400: '#42A6F5',
  500: '#2196F3',
  600: '#1D8EF1',
  700: '#1883EF',
  800: '#1479ED',
  900: '#0B68EA',
  A100: '#FFFFFF',
  A200: '#E1ECFF',
  A400: '#AECCFF',
  A700: '#95BCFF',
  contrastDefaultColor: 'light'
};
var secondary = {
  50: '#fefefe',
  100: '#fcfcfc',
  200: '#fafafa',
  300: '#f7f7f7',
  400: '#f6f6f6',
  500: '#f4f4f4',
  600: '#f3f3f3',
  700: '#f1f1f1',
  800: '#efefef',
  900: '#ececec',
  A100: '#ffffff',
  A200: '#ffffff',
  A400: '#ffffff',
  A700: '#ffffff',
  contrastDefaultColor: 'light'
};
var error = {
  50: '#fce5e4',
  100: '#f7beba',
  200: '#f2938d',
  300: '#ed685f',
  400: '#e9473c',
  500: '#e5271a',
  600: '#e22317',
  700: '#de1d13',
  800: '#da170f',
  900: '#d30e08',
  A100: '#fffcfc',
  A200: '#ffcac9',
  A400: '#ff9896',
  A700: '#ff7f7d',
  contrastDefaultColor: 'light'
};
var warn = {
  50: '#FCF5E7',
  100: '#F8E7C3',
  200: '#F4D79B',
  300: '#F0C772',
  400: '#ECBB54',
  500: '#E9AF36',
  600: '#E6A830',
  700: '#E39F29',
  800: '#DF9622',
  900: '#D98616',
  A100: '#FFFFFF',
  A200: '#FFEDD7',
  A400: '#FFD5A4',
  A700: '#FFCA8B'
};
var success = {
  50: '#F0FAE4',
  100: '#D8F2BC',
  200: '#BFE990',
  300: '#A5E064',
  400: '#91DA42',
  500: '#7ED321',
  600: '#76CE1D',
  700: '#6BC818',
  800: '#61C214',
  900: '#4EB70B',
  A100: '#EDFFE4',
  A200: '#CBFFB1',
  A400: '#AAFF7E',
  A700: '#99FF64'
};
var _default = {
  type: 'light',
  background: {
    default: '#F2F3F4'
  },
  primary: {
    light: primary[300],
    main: primary[500],
    dark: primary[700]
  },
  secondary: {
    light: secondary[50],
    main: secondary[50],
    dark: secondary[50]
  },
  error: {
    extraLight: error[50],
    light: error[300],
    main: error[500],
    dark: error[700],
    extraDark: error[900]
  },
  warn: {
    extraLight: warn[50],
    light: warn[300],
    main: warn[500],
    dark: warn[700],
    extraDark: warn[900]
  },
  success: {
    extraLight: success[50],
    light: success[300],
    main: success[500],
    dark: success[700],
    extraDark: success[900]
  }
};
exports.default = _default;